import { render, staticRenderFns } from "./RoofCalRedirect.vue?vue&type=template&id=656c9124&scoped=true"
import script from "./RoofCalRedirect.vue?vue&type=script&lang=js"
export * from "./RoofCalRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656c9124",
  null
  
)

export default component.exports